import React from "react";
import { Stethoscope } from "lucide-react";
import CrudModule, { useEmployees } from "@/components/CrudModule";
import { AsoUpdate, AsoAlertsButton } from "@/components/AsoUpdate";
import { AsoHistory } from "@/components/AsoHistory";

export default function Medicine() {
  const employees = useEmployees();
  return (
    <CrudModule
      title="Medicina do Trabalho — Exames / ASO"
      subtitle="Controle de exames ocupacionais e ASO (PCMSO) — 1 ASO atual por colaborador, anteriores no histórico"
      icon={Stethoscope}
      endpoint="medical-records"
      exportKey="medical-records"
      testid="medicine"
      employees={employees}
      hideBatchImport
      headerExtra={<><AsoAlertsButton /><AsoUpdate onDone={() => setTimeout(() => window.location.reload(), 1500)} /></>}
      rowExtra={(row, reload) => row.employee_id ? <><AsoHistory employeeId={row.employee_id} employeeName={row.employee_name} /><AsoUpdate compact employeeId={row.employee_id} employeeName={row.employee_name} onDone={reload} /></> : null}
      columns={[
        { key: "exam_date", label: "Data" },
        { key: "employee_name", label: "Colaborador" },
        { key: "exam_type", label: "Tipo" },
        { key: "result", label: "Resultado", badge: true },
        { key: "valid_until", label: "Validade", badge: "validity" },
        { key: "doctor", label: "Médico" },
        { key: "doc", label: "ASO", file: true, idKey: "document_id" },
      ]}
      fields={[
        { name: "employee", label: "Colaborador", type: "employee", idKey: "employee_id", nameKey: "employee_name", required: true, full: true },
        { name: "exam_type", label: "Tipo de exame", type: "select", options: ["Admissional", "Periódico", "Demissional", "Retorno ao Trabalho", "Mudança de Função"], default: "Admissional" },
        { name: "exam_date", label: "Data do exame", type: "date", required: true },
        { name: "valid_until", label: "Validade do ASO", type: "date" },
        { name: "result", label: "Resultado", type: "select", options: ["Apto", "Apto com restrição", "Inapto"], default: "Apto" },
        { name: "doctor", label: "Médico responsável", type: "text" },
        { name: "document", label: "ASO digitalizado (upload) — ao trocar o PDF, a IA atualiza os campos", type: "file", idKey: "document_id", nameKey: "document_name", full: true, aiFill: "/medical-records/extract-aso" },
      ]}
    />
  );
}
